import { Injectable } from '@angular/core';
import { NewsfeedApiService } from '@epicuro-next/data/engagement/engagement-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import * as actions from '../actions';

@Injectable()
export class PinEffects {
  public pinArticle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.pinArticle),
      mergeMap((action) =>
        this.feedService.pin(action.id).pipe(
          map(() => actions.pinArticleSuccess({ id: action.id })),
          catchError(() => of(actions.pinArticleFail())),
        ),
      ),
    ),
  );

  public unpinArticle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.unpinArticle),
      mergeMap((action) =>
        this.feedService.unpin(action.id).pipe(
          map(() => actions.unpinArticleSuccess({ id: action.id })),
          catchError(() => of(actions.unpinArticleFail())),
        ),
      ),
    ),
  );

  /** Dependencies */
  constructor(
    private actions$: Actions,
    private feedService: NewsfeedApiService,
  ) {}
}
